import axios from "axios";
import { BaseUrl } from "./api";
import {
    START_ADD_PROJECT_SUPER_CLASS,
    ADD_PROJECT_SUPER_CLASS_SUCCESS,
    ADD_PROJECT_SUPER_CLASS_FAILED,
    START_FETCH_PROJECT_SUPER_CLASS,
    FETCH_PROJECT_SUPER_CLASS_SUCCESS,
    FETCH_PROJECT_SUPER_CLASS_FAILED,
} from "./types";

export const fetchProjectSuperClassList = (token) => {
    return async (dispatch) => {
        dispatch({
            type: START_FETCH_PROJECT_SUPER_CLASS,
        });
        try {
            const res = await axios.get(`${BaseUrl}/project_classes`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (res.statusText == "OK") {
                dispatch({
                    type: FETCH_PROJECT_SUPER_CLASS_SUCCESS,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: FETCH_PROJECT_SUPER_CLASS_FAILED,
                    payload: "Fetching project category list failed",
                });
            }
        } catch (error) {
            dispatch({
                type: FETCH_PROJECT_SUPER_CLASS_FAILED,
                payload: error.message,
            });
        }
    };
};
export const addProjectSuperClass = (data, token) => {
    return async (dispatch) => {
        dispatch({
            type: START_ADD_PROJECT_SUPER_CLASS,
        });
        try {
            const res = await axios.post(`${BaseUrl}/project_class`, data, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (res.data.status) {
                dispatch({
                    type: ADD_PROJECT_SUPER_CLASS_SUCCESS,
                    payload: res.data.message,
                });
            } else {
                dispatch({
                    type: ADD_PROJECT_SUPER_CLASS_FAILED,
                    payload: res.data.message,
                });
            }
        } catch (error) {
            dispatch({
                type: ADD_PROJECT_SUPER_CLASS_FAILED,
                payload: error.message,
            });
        }
    };
};
